import { render, staticRenderFns } from "./SectionDivisionModal.vue?vue&type=template&id=2b1e1880&scoped=true&"
import script from "./SectionDivisionModal.vue?vue&type=script&lang=js&"
export * from "./SectionDivisionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1e1880",
  null
  
)

export default component.exports